import React, { useState, useEffect } from 'react';
import { Upload, Plus, Trash2, Edit, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdminTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem('templates');
    if (saved) {
      setTemplates(JSON.parse(saved));
    }
  }, []);

  const handleTemplateUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const originalWidth = img.naturalWidth || img.width;
          const originalHeight = img.naturalHeight || img.height;

          const newTemplate = {
            id: Date.now(),
            name: prompt('Nhập tên mẫu thiệp:', 'Mẫu thiệp mới') || 'Mẫu thiệp mới',
            imageUrl: event.target.result,
            width: originalWidth,
            height: originalHeight,
            orientation: originalWidth > originalHeight ? 'landscape' : 'portrait',
            fields: {
              photo: {
                x: originalWidth * 0.35,
                y: originalHeight * 0.25,
                width: 300,
                height: 300,
                shape: 'circle',
                borderRadius: 0,
                fit: 'cover'
              },
              name: {
                x: originalWidth * 0.5,
                y: originalHeight * 0.6,
                fontSize: Math.round(originalWidth * 0.05),
                fontFamily: 'Arial',
                fontWeight: 'bold',
                color: '#000000',
                colorType: 'solid',
                gradientColor1: '#FFD700',
                gradientColor2: '#FF6B6B',
                gradientAngle: 45,
                align: 'center',
                width: 200,
                height: 70
              },
              title: {
                x: originalWidth * 0.5,
                y: originalHeight * 0.7,
                fontSize: Math.round(originalWidth * 0.035),
                fontFamily: 'Arial',
                fontWeight: 'normal',
                color: '#666666',
                colorType: 'solid',
                gradientColor1: '#FFD700',
                gradientColor2: '#FF6B6B',
                gradientAngle: 45,
                align: 'center',
                width: 180,
                height: 60
              }
            }
          };

          const updatedTemplates = [...templates, newTemplate];
          setTemplates(updatedTemplates);
          localStorage.setItem('templates', JSON.stringify(updatedTemplates));
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const deleteTemplate = (id) => {
    if (window.confirm('Xóa mẫu thiệp này?')) {
      const updated = templates.filter(t => t.id !== id);
      setTemplates(updated);
      localStorage.setItem('templates', JSON.stringify(updated));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
            <Settings className="w-8 h-8" />
            Quản lý mẫu thiệp
          </h1>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-gray-600 text-white rounded-xl hover:bg-gray-700 transition"
          >
            Quay lại trang chính
          </button>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-10 text-center border-2 border-dashed border-blue-300">
          <input
            type="file"
            accept="image/*"
            onChange={handleTemplateUpload}
            className="hidden"
            id="template-upload"
          />
          <label htmlFor="template-upload" className="cursor-pointer block">
            <Plus className="w-16 h-16 text-blue-500 mx-auto mb-4" />
            <p className="text-xl font-bold text-gray-700 mb-2">Thêm mẫu thiệp mới</p>
            <p className="text-gray-500">Click để upload ảnh mẫu từ team design</p>
          </label>
        </div>

        <h2 className="text-2xl font-bold mb-6 text-gray-800">Danh sách mẫu hiện có</h2>

        {templates.length === 0 ? (
          <p className="text-center text-gray-600 text-lg">Chưa có mẫu nào. Hãy thêm mẫu mới ở trên!</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {templates.map((template) => (
              <div key={template.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <img src={template.imageUrl} alt={template.name} className="w-full h-48 object-cover" />
                <div className="p-4">
                  <h3 className="font-bold text-lg mb-2">{template.name}</h3>
                  <p className="text-sm text-gray-600 mb-4">
                    {template.width} × {template.height}px
                  </p>
                  <div className="flex gap-3">
                    <button
                      onClick={() => navigate(`/admin/edit/${template.id}`)}
                      className="flex-1 bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition"
                    >
                      Chỉnh sửa
                    </button>
                    <button
                      onClick={() => deleteTemplate(template.id)}
                      className="flex-1 bg-red-500 text-white py-2 rounded-lg hover:bg-red-600 transition"
                    >
                      Xóa
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminTemplates;